import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ 
  className = '', 
  disabled = false, 
  variant = 'outline',
  size = 'medium',
  style = {} 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!disabled) {
      navigate(-1);
    }
  };

  return (
    <omk-icon-button
      onClick={handleClick}
      disabled={disabled}
      variant={variant}
      size={size}
      className={className}
      style={{ ...style, borderRadius: '8px' }}
      aria-label="Go back"
      title="Go back"
    >
      <omk-icon>arrow_back</omk-icon>
    </omk-icon-button>
  );
};

export default BackButton;